import { render, staticRenderFns } from "./OtherSettingsList.vue?vue&type=template&id=f01e53be&scoped=true&"
import script from "./OtherSettingsList.vue?vue&type=script&lang=js&"
export * from "./OtherSettingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01e53be",
  null
  
)

export default component.exports